import { Notification } from 'element-ui';
/**
 * 设置页面标题
 * @param title 标题名称
 */
export const _title = title => {
  title = title || '紫光云-全球领先的云服务商';
  window.document.title = title;
};
export const notify = (type, title, message)=>{
  return Notification({
    type: type || 'info',
    title: title || '提示',
    message: message
  })
};
// 获取dom
export const _$ = el => {
  return document.querySelectorAll(el);
};

export const throttle = (func, wait, options) => {
  let timeout, context, args, result;
  let previous = 0;
  if (!options) options = {};

  let later = function() {
    previous = options.leading === false ? 0 : new Date().getTime();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };

  let throttled = (...argument) => {
    let now = new Date().getTime();
    if (!previous && options.leading === false) previous = now;
    let remaining = wait - (now - previous);
    context = this;
    args = argument;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
  return throttled;
};

// 判断数据是否为空（对象、数组等） —— 当校验值为空/null/undefined/0/false时，返回true
export const _isEmpty = data => {
  if (data === null) {
    return true;
  }
  if (typeof data === 'object' && data.constructor === Array) {
    return data.length === 0;
  } else if (typeof data === 'object' && data.constructor === Object) {
    return JSON.stringify(data) === '{}';
  } else {
    return Boolean(!data);
  }
};

// 拼接对象
export const _extend = function() {
  // 对象类型判断
  let isObj = data => {
    return typeof data === 'object' && data.constructor === Object;
  };
  switch (arguments.length) {
    // 传入参数的数量
    case 0:
      return {};
    case 1:
      return arguments[0];
    default: {
      let obj = isObj(arguments[0]) ? arguments[0] : {}; // 取第一个对象or空对象
      for (let i = 1; i < arguments.length; i++) {
        let item = arguments[i]; // 取传入的第几个参数（从1开始）
        if (isObj(item)) {
          for (let j in item) {
            let val = item[j];
            if (isObj(val)) {
              obj[j] = _extend(obj[j], val);
            } else {
              obj[j] = val;
            }
          }
        }
      }
      return obj;
    }
  }
};

export const _isUndefined = obj => {
  return obj === void 0;
};

export const _isFunction = obj => {
  return typeof obj == 'function' || false;
};

export const _isNaN = obj => {
  return toString.call(obj) === '[object Number]' && isNaN(obj);
};

export const _isNull = obj => {
  return obj === null;
};

export const _bind = (func, context) => {
  let bound = function() {
    if (this instanceof bound) {
      let obj = new Object();
      obj.prototype = func.prototype;
      obj.prototype.constructor = func;
      let res = func.call(obj);
      if (typeof res == 'function' || (typeof res == 'object' && !!res))
        return res;
      else return obj;
    } else {
      return func.call(context);
    }
  };
  return bound;
};
export const formatTime = (input) => {
  let date = new Date(input);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let seconds = date.getSeconds();
  return [hours, minutes, seconds].map((n) => {
      n = n.toString();
      return n[1] ? n : '0' + n;
  }).join(":")+'\n'+[year, month, day].map((n) => {
    n = n.toString();
    return n[1] ? n : '0' + n;
}).join("-") + "\n" 
}
export const formatTimeDate = (input) => {
  let date = new Date(input);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  return [year, month, day].map((n) => {
    n = n.toString();
    return n[1] ? n : '0' + n;
}).join("-") + "\n" 
}
/**
 * @param params 包含error， title， message
 * @param params.error 请求的返回值, 包含具体的错误码， 错误信息等
 * @param params.title Notification.error头部信息， 默认是'错误'
 * @param params.message Notification.error具体提示信息，默认是'获取信息失败'
 * @returns 子用户没有访问权限时不弹出Notification， 在axios响应拦截器中做统一处理 （axiosConfig.js line 109）， 其他情况正常弹出Notification
 */
 export const notificationError = params => {
  let user = localStorage.getItem('user'); // 获取用户信息
  let type = user ? JSON.parse(user).type : ''; // 获取用户类型， 主账号、子账号
  if (
    type == 'CHILD' &&
    params &&
    params.error &&
    params.error.response &&
    params.error.response.status &&
    params.error.response.status == '401'
  ) {
    return;
  } else {
    Notification.error({
      title: params.title || '错误',
      message: params.message || '获取信息失败',
      duration: params.duration || 3000,
    });
  }
};
export const generateUUID = () => {
  let d = new Date().getTime();
  if (window.performance && typeof window.performance.now === 'function') {
      d += performance.now();
  }
  let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      let r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
};
export const checkForm = (formName, self) => {
  return new Promise((resolve, reject) => {
      self.$refs[formName].validate(valid => {
          if(valid){
              resolve();
          }else{
              reject();
          }
      })
  })
};
export const camelToUnderline= (camelStr) => {
	return camelStr.replace(/[A-Z]/g,function(s){
		return ' '+s.toLowerCase();
	}).trim().replaceAll(' ','_');
}